export interface IUser {
    contextId?: string
    displayName: string
    email: string
    identifier?: string
    roles: string[]
    updateTimestamp: Date
    creationDate?: Date
    firstName: string;
    lastName: string;
    gender?: string;
    salutation?: string;
    title?: string;
    legalAddress?: IFirestoreUserLegalAdress;
    telephone?: string;
    signature?: string;
    invitationState?:string;
    language?:string;
    pendingRegistration?:string
    oobCode?:string
    contextMembership?: any
    contextIds?:string[]
    userGroupIds?:string[]
    selectedContextId?:string
}
interface IFirestoreUserLegalAdress {
    address1?: string;
    address2?: string;
    zip?: string;
    city?:string;
    country?: string;
    countryCode?:string
}

export interface IContextMembership {
    _structureVersion?: string
    identifier: string
    name: string
    roles: string[]
    rolesPerEvent: Map<string, Map<string, string[]>>
    updateTimestamp: Date
    contextName?:string
    email?:string
    invitationState?:string
    oobCode?:string
    userId?:string
}
